import React from 'react';
import { useTranslation } from 'react-i18next';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

export function NewCalendarRangeNavigator({
  label,
  onNextClick,
  onPreviousClick,
  onTodayClick,
}) {
  const { t } = useTranslation();

  return (
    <div className="new-calendar-range-navigator">
      <div
        className="new-calendar-button-group"
        role="group"
        aria-label={t('calendar-range-controls', { defaultValue: 'Calendar range controls' })}
      >
        <button type="button" className="new-calendar-button" onClick={onTodayClick}>
          <CalendarMonthOutlinedIcon fontSize="small" />
          {t('common-today', { defaultValue: 'Today' })}
        </button>
      </div>

      <button type="button" onClick={onPreviousClick} aria-label={t('calendar-previous-period', { defaultValue: 'Previous period' })}>
        <span className="icon-chevron-left"></span>
      </button>

      <span className="new-calendar-range-navigator__label">{label}</span>

      <button type="button" onClick={onNextClick} aria-label={t('calendar-next-period', { defaultValue: 'Next period' })}>
        <span className="icon-chevron-right"></span>
      </button>
    </div>
  );
}
